import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';

import type { CounterProps, CounterRef } from './_.type';

import useCounterHooks from './_.hook';

/** Counter. */
export default memo(
  forwardRef(function Counter<TValue>(props: CounterProps<TValue>, ref: ForwardedRef<CounterRef<TValue>>): ReactNode {
    const { render } = props;

    const { states } = useCounterHooks(props, ref);

    return render(states.value);
  }),
);
